// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9z-0";
export var optionCard = "_9z-1";